import React from 'react';
import 'src/assets/styles/react-table.scss';
import 'src/components/CustomAppLayout.scss';
import {DefaultColumnFilter, TPEReactTable} from "src/components/shared/TPEReactTable";
import {CLIExecutionRecord} from "src/models/reports/GetCLIExecutionRecords";
import {CLIJEStatus} from "src/components/reports/ReportStatus";

export default function JEStatusDashboardTableGrid(props: { loading: boolean, cliExecutionRecordTables: CLIExecutionRecord[] }) {
    const {loading, cliExecutionRecordTables = []} = props;

    const columnDefinitions = React.useMemo(() => [
            {
                accessor: "calculationNumber",
                Header: (e: any) => <div className="cell-text">CLI</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "jeStatus",
                Header: (e: any) => <div className="cell-text">JE Status</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text"><CLIJEStatus cliJEStatus={e.value}/></div>
            },
            {
                accessor: "groupNumber",
                Header: (e: any) => <div className="cell-text">Group Number</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "periodId",
                Header: (e: any) => <div className="cell-text">Period Id</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "apttusWorkbookName",
                Header: (e: any) => <div className="cell-text">Apttus Workbook Name</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "journalName",
                Header: (e: any) => <div className="cell-text">Journal Name</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "journalCurrency",
                Header: (e: any) => <div className="cell-text">Journal Currency</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "baseAmount",
                Header: (e: any) => <div className="cell-text">Base Amount</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "markupAmount",
                Header: (e: any) => <div className="cell-text">Markup Amount</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "accountingDate",
                Header: (e: any) => <div className="cell-text">Accounting Date</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "processedDate",
                Header: (e: any) => <div className="cell-text">Processed Date</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "calculationStartDate",
                Header: (e: any) => <div className="cell-text">Calculation Start Date</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "calculationEndDate",
                Header: (e: any) => <div className="cell-text">Calculation End Date</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            },
            {
                accessor: "jeError",
                Header: (e: any) => <div className="cell-text">JE Error</div>,
                Filter: DefaultColumnFilter,
                Cell: (e: any) => <div className="cell-text">{e.value}</div>
            }]
        , []);

    return (
            <TPEReactTable
                className={'jeStatusDashboardGrid'}
                isSearching={loading}
                data={cliExecutionRecordTables}
                columnDefinitions={columnDefinitions}
                emptyMessage = {'There are no CLI Execution Records for the selected accounting period, Group No, JE Status & Workbook Name'}
                sortable={false}/>
    )}